export const afterPaint = (task: () => void) => {
  if (typeof window === "undefined" || typeof window.requestAnimationFrame !== "function") {
    task()
    return
  }
  window.requestAnimationFrame(() => window.setTimeout(task, 0))
}
